import { motion } from "framer-motion";
import { Sparkle } from "lucide-react";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 36, className }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.85, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, delay = 0.15, className }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className="block"
            initial={{ y: "112%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.95, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function FadeIn({ children, delay = 0, className }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.9, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}

export function Marquee({ items }) {
  const row = [...items, ...items];
  return (
    <div data-testid="certifications-marquee" className="overflow-hidden border-y border-forest/10 bg-white/70 py-5">
      <div className="flex w-max animate-marquee items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap font-serif text-lg italic text-forest/75">{item}</span>
            <Sparkle className="mx-10 h-3.5 w-3.5 shrink-0 text-terracotta" fill="currentColor" />
          </span>
        ))}
      </div>
    </div>
  );
}

export function SectionHeading({ kicker, title, className }) {
  return (
    <Reveal className={className}>
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-terracotta-dark">{kicker}</p>
      <h2 className="mt-4 font-serif text-3xl font-semibold leading-tight tracking-tight text-forest-deep sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
  );
}
